export const statusId = {
  TRM: "trm_status",
  TBL: "tbl_status",
  COL: "col_status",
  DSR: "bo_status",
};
